import { render } from "./SaveXls.vue?vue&type=template&id=5d902219"
import script from "./SaveXls.vue?vue&type=script&lang=js"
export * from "./SaveXls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__